import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface the real error in the browser console for debugging.
    console.error("App crashed:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            background: "#0A0A09",
            color: "#F0EDE8",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <h1 style={{ color: "#E8621A", fontSize: "1.5rem", marginBottom: "12px" }}>
            Something went wrong
          </h1>
          <p style={{ maxWidth: 560, opacity: 0.8, marginBottom: 16 }}>
            The page failed to load. Please refresh. If this keeps happening, the details below help debugging.
          </p>
          <pre
            style={{
              maxWidth: 640,
              overflow: "auto",
              background: "#141312",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 8,
              padding: 12,
              fontSize: 12,
              color: "#a19d94",
              textAlign: "left",
            }}
          >
            {String(this.state.error && this.state.error.stack ? this.state.error.stack : this.state.error)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}
